import CreateVisitModal from '/@/components/field-list-v2/components/sidebar/components/create-visit-modal';
import { useFieldById } from '/@/hooks/fields';
import type { CropMonitoring } from '/@/types/crop-monitoring';
import type { RegistryAddStep } from './types';

const CreateRegistryVisitReport = ({
    open,
    onClose,
    setStep,
    fieldId,
    cropMonitoring: _cropMonitoring,
}: {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    setStep: (step: RegistryAddStep) => void;
    fieldId?: number;
    cropMonitoring?: CropMonitoring;
}) => {
    const fieldQuery = useFieldById({ id: fieldId ?? 0 }, { enabled: !!fieldId });
    return (
        <CreateVisitModal
            open={open}
            setOpen={onClose}
            userNodeId={fieldQuery.data?.userNode ?? 0}
            field={fieldQuery.data}
        />
    );
};

export default CreateRegistryVisitReport;
